import Request from '@hotmart/request'

export const redirectTheBuyer = () => next => (action: any) => {
  const clearStoragesToAvoidConflitWithPurchaseApp = (): void => {
    sessionStorage.clear()
    localStorage.clear()
  }

  if (action.type === 'loggedUser/setUser' && action?.payload?.isBuyer) {
    Request.cancelAll()
    clearStoragesToAvoidConflitWithPurchaseApp()
    location.replace(`${process.env.URL_DRIVE}`)
  }

  return next(action)
}
